export const SUPPORTED_LANGUAGES = {
  EN: 'en',
  ES: 'es',
} as const

export const DATE_FORMAT_LOCALES = {
  EN: 'en-US',
  ES: 'es-ES',
} as const

// Language names are always shown in their own language, regardless of the active UI language
export const LANGUAGE_LABELS = {
  [SUPPORTED_LANGUAGES.EN]: 'English',
  [SUPPORTED_LANGUAGES.ES]: 'Español',
} as const
